import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { PlsService } from '../pls.service';
import { Observable, map } from 'rxjs';

@Component({
    selector: 'brightside-web-pls-contest-rewards',
    templateUrl: './pls-contest-rewards.component.html',
    styleUrls: ['./pls-contest-rewards.component.scss'],
    standalone: false
})
export class PlsContestRewardsComponent implements OnInit {
  numberOfWinners$: Observable<number | undefined>;

  constructor(private _router: Router, private _route: ActivatedRoute, private _plsService: PlsService) {}

  ngOnInit(): void {
    this.numberOfWinners$ = this._plsService.getContestInfo().pipe(
      map((contests) => contests.find((c: any) => [1, 2].includes(c.id))),
      map((contest) => contest?.messageValues?.numberOfWinners)
    );
  }

  backToSavingsDashboard(): void {
    this._router.navigate(['accounts', 'savings', 'dashboard']);
  }

  showRules(): void {
    this._router.navigate(['../contest-rules'], { relativeTo: this._route });
  }
}
